import { Card, CardBody, CardHeader, Heading, Icon, Skeleton, Stack, Text } from '@chakra-ui/react';
import { TemplateIcon } from '@heroicons/react/outline';
import { useParams } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import { FundraisingStatus, useGetFundraisingsQuery } from '@blockpulse3/graphql/hooks';
import { ErrorQueryCard } from '@blockpulse3/ui/commons';

import { ShareTransferRegisterTable } from './ShareTransferRegisterTable';

type Props = unknown;

/**
 * PartialShareTransferRegisters.
 * Display finalized Fundraisings RMT.
 *
 * @param {Props}
 * @returns {JSX.Element}
 */
export function PartialShareTransferRegisters(): JSX.Element {
  const i18nShareTransferRegister = useTranslations('CaptableShareTransferRegister');

  const { companyId = '' } = useParams();

  const { data, loading, error } = useGetFundraisingsQuery({
    variables: { companyId, status: FundraisingStatus.FINALIZED },
    fetchPolicy: 'cache-and-network',
  });

  if (loading) {
    return (
      <Skeleton>
        <Card h="270px" />
      </Skeleton>
    );
  }

  if (error) {
    return <ErrorQueryCard />;
  }

  const fundraisings = data?.fundraisings || [];

  return (
    <Stack spacing="4">
      <Card key={companyId}>
        <CardHeader
          as={Stack}
          direction={{ base: 'column', md: 'row' }}
          justifyContent="space-between"
        >
          <Heading size="md">{i18nShareTransferRegister('Title')}</Heading>
        </CardHeader>
        <CardBody>
          <Stack layerStyle="emptyState">
            <Icon as={TemplateIcon} boxSize="40px" color="gray.500" />
            <Stack alignItems="center" spacing="0">
              <Text>{i18nShareTransferRegister('EmptyStateTitle-1')}</Text>
              <Text>{i18nShareTransferRegister('EmptyStateTitle-2')}</Text>
            </Stack>
          </Stack>
        </CardBody>
      </Card>
      {fundraisings.map((fundraising) => (
        <ShareTransferRegisterTable key={fundraising.id} fundraising={fundraising} />
      ))}
    </Stack>
  );
}

export type PartialShareTransferRegistersProps = Props;
